<div class="pb-4 mx-4 mt-4 md:mx-6 md:mt-6 md:pb-6" [ngClass]="{ 'border-b': !isLast() }">
	<a
		[routerLink]="categorySlug()"
		class="flex items-center justify-between w-full gap-4"
	>
		<span>
			<span
				class="block text-lg font-semibold leading-7 text-gray-900 lowercase first-letter:uppercase"
				>{{ categoryName() }}</span
			>
			<span class="block text-gray-500">
				{{ articleCountText() }}
			</span>
			<span class="block text-gray-500">{{ categoryDesc() }}</span>
		</span>
		<uc-arrow-right-v2-svg />
	</a>
</div>
